<div class="input-increase-decrease">
  <button (click)="decrementToOne($event, identificador)" [disabled]="isZero" class="buton-less" mat-icon-button>
    <mat-icon class="btn-remove">remove</mat-icon>
  </button>
  <input
    id="{{ identificador + 'id' }}"
    appearance="outline"
    class="input-increase-decrase-value"
    type="number"
    [value]="valueEntry != '' ? valueEntry : minValue.toString()"
    [autofocus]="true"
    (change)="valueChanged($event, identificador)" />
  <button (click)="incrementToOne($event, identificador)" [disabled]="isMax" class="buton-add" mat-icon-button>
    <mat-icon class="btn-add">add</mat-icon>
  </button>
</div>
